export const SLUG_CR = 'cr' as const
export const SLUG_MC = 'mc' as const

export type SlugType = 'cr&mc' | 'cr' | 'mc'
export const APP_SLUG: SlugType =
  (process.env.NEXT_PUBLIC_SLUG as SlugType) ?? SLUG_CR
export const APP_SLUGS = [SLUG_MC, SLUG_CR]
